import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Index from '../components/Contact/Reserve/Index.vue';

const app = createApp(Index);
app.use(createPinia());
app.mount('#contact-us-reserve');
